import React from "react";
import { useNavigate } from "react-router-dom";
import "./AlgoDashboard.css";

const summaryCards = [
  { label: "Total Strategies", value: "0", note: "Active strategies", icon: "fa-bolt", tone: "purple" },
  { label: "Live P&L", value: "₹0.00", note: "Today's P&L", icon: "fa-line-chart", tone: "green" },
  { label: "Total Orders", value: "0", note: "Today", icon: "fa-exchange", tone: "blue" },
  { label: "Connected Brokers", value: "0", note: "Active", icon: "fa-link", tone: "orange" },
];

const AlgoDashboard = () => {
  const navigate = useNavigate();

  return (
    <main className="algo-dashboard">
      <section className="algo-dashboard__summary" aria-label="Trading summary">
        {summaryCards.map((card) => (
          <article className="algo-summary-card" key={card.label}>
            <div className={`algo-summary-card__icon algo-summary-card__icon--${card.tone}`}>
              <i className={`fa ${card.icon}`} aria-hidden="true"></i>
            </div>
            <div>
              <span>{card.label}</span>
              <strong className={card.label === "Live P&L" ? "algo-summary-card__profit" : ""}>
                {card.value}
              </strong>
              <small>{card.note}</small>
            </div>
          </article>
        ))}
      </section>

      <section className="algo-dashboard__grid">
        <article className="algo-panel">
          <div className="algo-panel__heading">
            <div>
              <h2>Broker Status</h2>
              <p>Your connected trading accounts</p>
            </div>
            <button onClick={() => navigate("/brokers")}>View all</button>
          </div>

          <div className="algo-empty-state">
            <span className="algo-empty-state__icon">
              <i className="fa fa-briefcase" aria-hidden="true"></i>
            </span>
            <h3>No brokers connected</h3>
            <p>Connect a broker to start algo trading.</p>
            <button onClick={() => navigate("/brokers")}>Connect Broker</button>
          </div>
        </article>

        <article className="algo-panel algo-panel--orders">
          <div className="algo-panel__heading">
            <div>
              <h2>Recent Orders</h2>
              <p>Latest orders placed by your strategies</p>
            </div>
            <button>View all</button>
          </div>

          <div className="algo-orders-table">
            <div className="algo-orders-table__row algo-orders-table__head">
              <span>Order ID</span>
              <span>Strategy</span>
              <span>Symbol</span>
              <span>Status</span>
              <span>Time</span>
            </div>
            <div className="algo-orders-table__empty">
              <i className="fa fa-list-alt" aria-hidden="true"></i>
              <strong>No orders yet</strong>
              <span>Your recent algo orders will appear here.</span>
            </div>
          </div>
        </article>
      </section>
    </main>
  );
};

export default AlgoDashboard;
